import { CheckIcon, XIcon } from 'lucide-react'
import FileAnswer from './FileAnswer'
import Card from 'app/frontend/base/components/Card'

const ApplicationAnswers = ({
  answers,
}: {
  answers: wowaudit.ApplicationAnswer[]
}) => {
  return (
    <>
      {answers && answers.length > 0 && (
        <div>
          <h3 className='text-lg font-semibold mb-3 mt-6'>Answers</h3>
          <div className='space-y-4'>
            {answers.map((answer) => (
              <Card key={answer.id}>
                <div className='font-semibold text-accent-foreground mb-3 border-b pb-2'>
                  {answer.questionDescription}
                </div>
                <div className='whitespace-pre-wrap wrap-break-word'>
                  {answer.questionType === 'file' &&
                  answer.attachments.length > 0 ? (
                    <FileAnswer answer={answer} />
                  ) : answer.questionType === 'checkbox' ? (
                    <span>
                      {answer.response === 'true' ? (
                        <CheckIcon className='text-success-foreground' />
                      ) : (
                        <XIcon className='text-destructive-foreground' />
                      )}
                    </span>
                  ) : answer.response ? (
                    answer.response
                  ) : (
                    <span className='italic text-muted-foreground'>
                      No response
                    </span>
                  )}
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default ApplicationAnswers
